import { render, staticRenderFns } from "./RequiredField.vue?vue&type=template&id=2fc46cce"
import script from "./RequiredField.vue?vue&type=script&lang=js"
export * from "./RequiredField.vue?vue&type=script&lang=js"
import style0 from "./RequiredField.vue?vue&type=style&index=0&id=2fc46cce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports